import { Pipe, PipeTransform } from '@angular/core';
import { assertUnreachable } from '@evorait/pace-core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import {
    faCheckSquare,
    faCogs,
    faExchangeAlt,
    faFile,
    faShieldAlt,
    faTasks,
    faWrench,
} from '@fortawesome/free-solid-svg-icons';
import { FormListEntryState } from '../../../types/form-list';
import { FormsConstants } from '../../../types/forms-constants';

@Pipe({
    name: 'formListIcon',
})
export class FormsListIconPipe implements PipeTransform {
    public transform(value: FormListEntryState): IconDefinition {
        switch (value.type) {
            case FormsConstants.FORMTYPE.MAINTENANCE:
                return faWrench;
            case FormsConstants.FORMTYPE.SAFETY:
                return faShieldAlt;
            case FormsConstants.FORMTYPE.TRAININGCHECKLIST:
                return faCheckSquare;
            case FormsConstants.FORMTYPE.PREINSTALLATION_REPORT:
            case FormsConstants.FORMTYPE.INSTALLATION_REPORT:
            case FormsConstants.FORMTYPE.INSTALLATION_STARTUP_REPORT:
            case FormsConstants.FORMTYPE.STARTUP_REPORT:
            case FormsConstants.FORMTYPE.SOFTWARE_HANDLING_REPORT:
            case FormsConstants.FORMTYPE.TUNE_UP_REPORT:
            case FormsConstants.FORMTYPE.QUALITY_ASSURANCE_REPORT:
            case FormsConstants.FORMTYPE.DISASSEMBLY_REPORT:
            case FormsConstants.FORMTYPE.RECONDITIONING_REPORT:
            case FormsConstants.FORMTYPE.CUSTOMER_ACCEPTANCE_REPORT:
            case FormsConstants.FORMTYPE.COMMISSIONING_REPORT:
            case FormsConstants.FORMTYPE.DISPOSAL_REPORT:
            case FormsConstants.FORMTYPE.UPGRADE_REPORT:
                return faCogs;
            case FormsConstants.FORMTYPE.MAINTENANCE_REPORT:
                return faWrench;
            case FormsConstants.FORMTYPE.SAFETY_RELATED_TEST_REPORT:
                return faShieldAlt;
            case FormsConstants.FORMTYPE.APPLICATION_TRAINING_REPORT:
                return faTasks;
            case FormsConstants.FORMTYPE.PRE_TRAINING_CLARIFICATION_REPORT:
                return faTasks;
            case FormsConstants.FORMTYPE.TROUBLESHOOTING_REPORT:
                return faExchangeAlt;
            case FormsConstants.FORMTYPE.REPLACEMENT_REPORT:
                return faExchangeAlt;
            case FormsConstants.FORMTYPE.ADJUSTMENT_REPORT:
                return faExchangeAlt;
            case FormsConstants.FORMTYPE.CONFIGURATION_REPORT:
                return faExchangeAlt;
            case FormsConstants.FORMTYPE.SAFETY_INFORMATION_REPORT:
            case FormsConstants.FORMTYPE.SITE_PLANNING_REPORT:
            case FormsConstants.FORMTYPE.UPDATE_REPORT:
            case FormsConstants.FORMTYPE.UNKNOWN:
                return faFile; // these report types should not be encountered in PACE Forms as far as we know
            default:
                assertUnreachable(value.type);
        }
    }
}
